const TRACE_ID_RE = /^[0-9a-f]{32}$/;

export function isValidTraceId(value: string): boolean {
  return TRACE_ID_RE.test(value);
}
